import { createApp } from 'vue';
import PdfToMdConverter from '@/Components/PdfToMdConverter.vue';
import '@styles/app.css';

createApp(PdfToMdConverter).mount('#pdf-to-md-converter');
